"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recursivelyWrapStringChildrenWithSpans = recursivelyWrapStringChildrenWithSpans;
var _react = _interopRequireDefault(require("react"));
function recursivelyWrapStringChildrenWithSpans(_children) {
  return _react["default"].Children.toArray(_children).map(function (child) {
    if (typeof child === 'string') {
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: child
      }, child);
    } else if (/*#__PURE__*/_react["default"].isValidElement(child)) {
      return /*#__PURE__*/_react["default"].cloneElement(child, undefined, recursivelyWrapStringChildrenWithSpans(child.props.children));
    }
    return child;
  });
}
//# sourceMappingURL=HBButton.utils.js.map